const dev = {
  fingerprint: {
    ordId: '1snn5n9w',
    login: 'visanetgt_qpay',
  },
  apiGateway: {
    REGION: "us-east-1",
    URL: "https://devapi.viveloonline.com"
    // URL: "https://api.viveloonline.com"
  },
  wsService: {
    url: "wss://x75aacsh9k.execute-api.us-east-1.amazonaws.com/dev"
  },
  firebase: {
    apiKey: 'AIzaSyBaAZqKn4cdbLlbQw2ags8VPA6F1CLlSGo',
    databaseURL: 'https://vivelo-dev.firebaseio.com/'
  }
}
const prod = {
  fingerprint: {
    ordId: 'k8vif92e',
    login: 'visnetgt_sto_qpaypro',
  },
  apiGateway: {
    REGION: "us-east-1",
    URL: "https://api.viveloonline.com"
  },
  wsService: {
    //url: "wss://ws.viveloonline.com/shows/"
    url: "wss://e2llr85td3.execute-api.us-east-1.amazonaws.com/prod"
  },
  firebase: {
    apiKey: 'AIzaSyCtAW_AQuaShfDi1WqnhfsOFIsO4fM7GAA',
    databaseURL: 'https://vivelo-prod01.firebaseio.com/'
  }
}

const config = process.env.REACT_APP_STAGE === 'prod'
  ? prod
  : dev;

export default {
  // Add common config values here
  ...config
};